import React from 'react'
import { Button, TableRow, TableCell } from '@material-ui/core'
import { Close, Draggable } from '@ripley-ui/icon'
import { DropTargetMonitor, useDrag, useDrop } from 'react-dnd'
import { TableRowProps } from './interfaces/TableRowProps'
import styleOverride from './style'

export const ItemTypes = {
  BOX: 'box',
}

const DND_ITEM_TYPE = 'row'

const TableMasterDraggableRow: React.FC<TableRowProps> = (props) => {
  const { index } = props

  const classes = styleOverride()

  const dropRef = React.useRef(null)
  const dragRef = React.useRef(null)

  const getPossibleSourceIndex = (monitor: DropTargetMonitor) => {
    const elementHeight = dropRef.current.getBoundingClientRect().height
    const sourceTarget = monitor.getInitialSourceClientOffset()
    return Math.floor(sourceTarget.y / elementHeight)
  }

  const getPossibleDestinationIndex = () => {
    const dropTarget = dropRef.current.getBoundingClientRect()
    const elementHeight = dropTarget.height
    return Math.floor(dropTarget.y / elementHeight)
  }

  const getCell = (column) => {
    const dataReturn = props.row[column.id] ? props.row[column.id] : props.row
    return column.component
      ? column.component(dataReturn)
      : props.row[column.id]
  }

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: DND_ITEM_TYPE,
    drop(item: any, monitor) {
      const possibleSourceIndex = getPossibleSourceIndex(monitor)
      const possibleDestinationIndex = getPossibleDestinationIndex()
      const movementDiff = possibleDestinationIndex - possibleSourceIndex

      const result = {
        item: item,
        sourceIndex: item.index,
        destinationIndex: movementDiff + item.index,
      }

      props.onDragEnd(result)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: DND_ITEM_TYPE,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }))

  const opacity = isDragging ? 0 : 1

  preview(drop(dropRef))
  drag(dragRef)

  const isActive = canDrop && isOver
  let backgroundColor = 'white'
  if (isActive) {
    backgroundColor = '#f5f5f5'
  }

  return (
    <TableRow
      ref={dropRef}
      style={{ backgroundColor, opacity }}
      key={props.rowId}
    >
      <TableCell
        ref={dragRef}
        component="td"
        scope="row"
        className={classes.firstCellStyle}
      >
        <Draggable className={classes.draggableIcon} />
        {props.showIndex ? props.index + 1 : null}
      </TableCell>

      {(props.columns || []).map((column) => (
        <TableCell key={column.id + props.rowId} component="td" scope="row"
        className={classes.cellStyle}>
          {getCell(column)}
        </TableCell>
      ))}

      <TableCell
        component="td"
        scope="row"
        className={classes.lastCellStyle}
      >
        <Button onClick={() => props.onDelete(props.row)}>
          <Close className={classes.deleteIcon} />
        </Button>
      </TableCell>
    </TableRow>
  )
}

export default TableMasterDraggableRow
